import clsx from 'clsx'

const base =
  'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/50'

export function landingLinkClass(
  variant: 'primary' | 'ghost',
  size: 'sm' | 'md' = 'sm',
): string {
  return clsx(
    base,
    size === 'sm' && 'px-2.5 py-1.5 text-sm',
    size === 'md' && 'px-3 py-2 text-sm',
    variant === 'primary' &&
      'bg-accent-button text-white hover:bg-accent-button-hover',
    variant === 'ghost' &&
      'text-text-secondary hover:bg-surface-hover hover:text-text-primary',
  )
}
